export default __webpack_public_path__ + "assets/images/avatar.95f264.webp";